var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMaterialPeopleOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 51 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9104 20.9229C39.05 23.0542 41.25 25.9417 41.25 29.7917V36.6667H48.125C49.3854 36.6667 50.4167 35.6354 50.4167 34.375V29.7917C50.4167 24.7958 42.2354 21.8396 35.9104 20.9229Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 18.3333C23.3959 18.3333 27.5 14.2293 27.5 9.16667C27.5 4.10406 23.3959 0 18.3333 0C13.2707 0 9.16667 4.10406 9.16667 9.16667C9.16667 14.2293 13.2707 18.3333 18.3333 18.3333Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0833 18.3333C37.1479 18.3333 41.25 14.2312 41.25 9.16667C41.25 4.10208 37.1479 0 32.0833 0C31.0063 0 29.9979 0.229166 29.0354 0.549999C30.9375 2.91042 32.0833 5.9125 32.0833 9.16667C32.0833 12.4208 30.9375 15.4229 29.0354 17.7833C29.9979 18.1042 31.0063 18.3333 32.0833 18.3333Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3333 20.625C12.2146 20.625 0 23.6958 0 29.7917V34.375C0 35.6354 1.03125 36.6667 2.29167 36.6667H34.375C35.6354 36.6667 36.6667 35.6354 36.6667 34.375V29.7917C36.6667 23.6958 24.4521 20.625 18.3333 20.625Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMaterialPeopleOutline);
export default __webpack_public_path__ + "static/media/icon-material-people-outline.3e02be4c9e89d1da475237685b1d9646.svg";
export { ForwardRef as ReactComponent };